import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Space, MenuProps } from 'antd'
import clsx from 'clsx'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './project-select.module.scss'
import { useProjectStore } from '../../../../../entities/projects/stores/project.store'
import { useUserStore } from '../../../../../entities/user/stores/user.store'

export const ProjectSelect = () => {
  const { t } = useTranslation()
  const projectStore = useProjectStore()
  const userStore = useUserStore()
  const selectedProject = projectStore.project

  useEffect(() => {
    projectStore.loadProjects()
  }, [projectStore.loadProjects])

  const items: MenuProps['items'] =
    projectStore.projects.map((project) => ({
      key: project.id,
      label: project.name,
      onClick: () => {
        userStore.updateUser({ projectId: project.id })
        projectStore.setProject(project)
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          window.location.reload()
        }, 500)
      },
    })) ?? []

  if (items.length) {
    return (
      <Dropdown
        className={clsx(styles.projectDropdown)}
        menu={{ items }}
        overlayClassName={clsx(styles.projectDropdownOverlayClassName)}
      >
        <a
          className={clsx(styles.projectDropdownDropdownTrigger)}
          onClick={(e) => e.preventDefault()}
        >
          {selectedProject ? (
            <Space>
              {`${selectedProject?.name.substring(0, 80)}`}
              <DownOutlined />
            </Space>
          ) : (
            <Space>
              {t('projects.selectProject')}
              <DownOutlined />
            </Space>
          )}
        </a>
      </Dropdown>
    )
  } else {
    return (
      <a
        className={clsx(styles.projectDropdownDropdownTrigger)}
        onClick={(e) => e.preventDefault()}
      >
        <Space>
          {t('projects.selectProject')}
          <DownOutlined />
        </Space>
      </a>
    )
  }
}
